export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_RESULT = 'LOGIN_RESULT';
export const LOGIN_CONFIRM_RESULT = 'LOGIN_CONFIRM_RESULT';

export const LOGIN_FORGOT_PASSWORD_OPEN_MODAL = 'LOGIN_FORGOT_PASSWORD_OPEN_MODAL';
export const LOGIN_FORGOT_PASSWORD_REQUEST = 'LOGIN_FORGOT_PASSWORD_REQUEST';
export const LOGIN_FORGOT_PASSWORD_RESULT = 'LOGIN_FORGOT_PASSWORD_RESULT';

export const LOGIN_CONFIRM_FORGOT_PASSWORD_REQUEST = 'LOGIN_CONFIRM_FORGOT_PASSWORD_REQUEST';
export const LOGIN_CONFIRM_FORGOT_PASSWORD_RESULT = 'LOGIN_CONFIRM_FORGOT_PASSWORD_RESULT';

export const LOGIN_CHECK_LOGIN_USER_BY_CODE = 'LOGIN_CHECK_LOGIN_USER_BY_CODE';

export const LOGIN_CHANGE_PASSWORD_OPEN_MODAL = 'LOGIN_CHANGE_PASSWORD_OPEN_MODAL';
export const LOGIN_CHANGE_PASSWORD_REQUEST = 'LOGIN_CHANGE_PASSWORD_REQUEST';
export const LOGIN_CHANGE_PASSWORD_RESULT = 'LOGIN_CHANGE_PASSWORD_RESULT';
export const LOGIN_LOGOUT_REQUEST = 'LOGIN_LOGOUT_REQUEST';
export const LOGIN_LOGOUT_RESULT = 'LOGIN_LOGOUT_RESULT';